import { isWeb } from 'affiny-core/helpers/targetCheck/targetCheck';
import { ConfiguredMiddleware } from 'wretch';
import { WretcherResponse } from 'wretch/dist/resolver';
import { authMiddleware } from '../middlewares/authMiddleware';
import { EResponseStatus } from '../middlewares/middlewaresHelpers';
import { picturesMiddleware } from '../middlewares/picturesMiddleware';
import { retryMiddleware } from '../middlewares/retryMiddleware';
import { getAffinyBaseEndPoint } from './baseEndpoint';

const shouldReceiptRetryStop = (response: WretcherResponse) =>
  response.status !== EResponseStatus.UNAUTHORIZED && response.status < 500;

const BaseWithMiddlewares = (middlewares: ConfiguredMiddleware[]) =>
  getAffinyBaseEndPoint().middlewares(middlewares);

export class AffinyEndpoint {
  private static get BaseWithRetry() {
    return BaseWithMiddlewares([retryMiddleware()]);
  }

  public static get BaseWithAuthentication() {
    return BaseWithMiddlewares([picturesMiddleware(), authMiddleware()]);
  }

  public static get Account() {
    return this.BaseWithAuthentication.url('/account');
  }

  public static get Announce() {
    return this.BaseWithAuthentication.url('/announce');
  }

  public static get Blacklist() {
    return this.BaseWithAuthentication.url('/blacklist');
  }

  public static get Blacklists() {
    return this.BaseWithAuthentication.url('/blacklists');
  }

  public static get CompatibilityReport() {
    return this.BaseWithAuthentication.url('/compatibility_report');
  }

  public static get ReportUser() {
    return this.BaseWithAuthentication.url('/complaint');
  }

  public static get Configuration() {
    return this[isWeb() ? 'BaseWithAuthentication' : 'BaseWithRetry'].url(
      '/configurations'
    );
  }

  public static get Counters() {
    return this.BaseWithAuthentication.url('/counter');
  }

  public static get Favorite() {
    return this.BaseWithAuthentication.url('/favorite');
  }

  public static get Rating() {
    return this.BaseWithAuthentication.url('/ratings');
  }

  public static get EligibleCategories() {
    return this.Payment.url('/eligible_categories');
  }

  public static get CustomerCare() {
    return this.BaseWithAuthentication.url('/customer_care');
  }

  public static get Geo() {
    return this.BaseWithRetry.url('/geo');
  }

  public static get MatchList() {
    return this.BaseWithAuthentication.url('/matchlist');
  }

  public static get Member() {
    return this.BaseWithAuthentication.url('/members');
  }

  public static get MemberPictures() {
    return this.BaseWithAuthentication.url('/members');
  }

  public static get Message() {
    return this.BaseWithAuthentication.url('/messages');
  }

  public static get Payment() {
    return this.BaseWithAuthentication.url('/payment');
  }

  public static get Receipt() {
    return BaseWithMiddlewares([
      retryMiddleware(shouldReceiptRetryStop),
      authMiddleware(),
    ]).url('/payment');
  }

  public static get PersonalityReport() {
    return this.BaseWithAuthentication.url('/personal_report');
  }

  public static get PhotoRequests() {
    return this.BaseWithAuthentication.url('/photo_request');
  }

  public static get Pictures() {
    return this.BaseWithAuthentication.url('/pictures');
  }

  public static get PhotoReveals() {
    return this.BaseWithAuthentication.url('/photo_reveal');
  }

  public static get Reflist() {
    return this.BaseWithAuthentication.url('/referentiallist');
  }

  public static get Registration() {
    return this.BaseWithRetry.url('/registration');
  }

  public static get ValidationPassword() {
    return this.BaseWithRetry.url('/registration/validation');
  }

  public static get Score() {
    return this.BaseWithAuthentication.url('/score');
  }

  public static get Thread() {
    return this.BaseWithAuthentication.url('/threads');
  }

  public static get Visit() {
    return this.BaseWithAuthentication.url('/visit');
  }

  public static get Visits() {
    return this.BaseWithAuthentication.url('/visits');
  }

  public static get Tracking() {
    return this.BaseWithRetry.url('/tracking');
  }
}
